import React from "react";
import { Route } from "react-router-dom";
import Homepage from "../../components/administratorHomePage/Homepage";

const administratorRoutes = [
  <Route
    path="administration/dashboard"
    key="admin-dash"
    element={<Homepage />}
  />,
];

export default administratorRoutes;
